import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockText from "../Block/BlockText";
import Block from "../Block/Block";
import BlockCard from "../Block/BlockCard";


import { useNavigate } from 'react-router-dom';

function Projects() {

  const navigate = useNavigate();
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockTitle fontSize="25px" fontWeight="normal">A compilation of projects I have worked on over the last years.</BlockTitle>
        </BlockContent>
      </Block>


      <Block gridTemplateColumns="300px 900px">
        <BlockContent>
          <BlockTitle>Funded Projects</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>My professional work includes contributions to several funded research projects. The following overview highlights the different collaborations I have been involved in.</BlockText>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="400px 400px 400px">
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/moveki2eah_logo2.webp'} onClick={() => navigate('/Projects/FundedProjects/MoVeKI2EAH')} title="MoVeKI2EAH" caption="The MoveKI2EAH project, funded by the Federal Ministry of Research, Technology and Space (BMFTR), aims to modernize AI teaching at the University of Applied Sciences Jena by creating easily integrable, comprehensible teaching units."/>
          {/* <BlockCard src={process.env.PUBLIC_URL + '/card_ssr.webp'} onClick={() => navigate('/Projects/FundedProjects/SSR')}/>
          <BlockCard src={process.env.PUBLIC_URL + '/card_flycamxr.webp'} onClick={() => navigate('/Projects/FundedProjects/FlyCamXR')}/> */}
        </BlockContent>

        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_flycamxr_2.webp'} onClick={() => navigate('/Projects/FundedProjects/FlyCamXR')} title="FlyCamXR" caption="This DAAD-sponsored project brings together the University of Applied Sciences Jena and the Anna University to strengthen collaboration between both institutions through joint research activities."/>
        </BlockContent>

        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/drone_search2.webp'} onClick={() => navigate('/Projects/FundedProjects/SSR')} title="SmartSense&Rescue" caption="Funded by the BMWE, this project with TU Berlin, Eurocommand, and Cham’s emergency service develops software to detect missing persons using drone-mounted optical and thermal cameras to assist rescue workers."/>
        </BlockContent>

        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/Homepage_FAUstairs_card.webp'} onClick={() => navigate('/Projects/FundedProjects/FAUstairs')} title="FAUstairs" caption="FAUstairs is a research project at Friedrich-Alexander University (FAU) dedicated to developing a modern, web-based learning platform. It aims to provide an accessible, flexible, and user-friendly environment for digital education."/>
        </BlockContent>
      </Block>

      {/* <Block width="100%">
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockTitle fontSize="25px" fontWeight="normal"></BlockTitle>
        </BlockContent>
      </Block> */}





      <Block colorTheme="light" gridTemplateColumns="300px 900px">
        <BlockContent>
          <BlockTitle>Datasets</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>I have developed and curated several datasets, each designed to address specific challenges and use cases. Below is an overview of these datasets.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="400px 400px 400px">
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_eva2.webp'} onClick={() => navigate('/Projects/Datasets/EVA')} title="EVA Dataset" caption="The Enhanced Visual Archive (EVA) is an evolving dataset of 3D reconstructions of small to medium objects, created with photogrammetry and structured light, with new items from time to time."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_huedataset3.webp'} onClick={() => navigate('/Projects/Datasets/HueBedroom')} title="HUE Dataset" caption="The HUE Dataset, created for my master’s thesis and featured in “Color Transfer of 3D Point Clouds XR Applications,” provides 3D room reconstructions under varying hue lamp lighting for evaluating color transfer algorithms."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_colortransferdataset2.webp'} onClick={() => navigate('/Projects/Datasets/ColorTransfer')} title="Color Transfer Dataset" caption="In my publication “A Software Test Bed for Evaluating Color Transfer Algorithms,” I introduced a diverse image dataset covering various scenes, sizes, and color depths for color transfer evaluation."/>
        </BlockContent>

        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_ctpublication2.webp'} onClick={() => navigate('/Projects/Datasets/CTPublication')} title="Color Transfer Publication Dataset" caption="Evaluating color transfer algorithms is difficult due to varied image sets and subjective assessments. This dataset standardizes comparisons with source, reference, and output images from multiple publications."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_eden-I_3.webp'} onClick={() => navigate('/Projects/Datasets/EDEN1')} title="EAH Dataset" caption="EAH is a dataset created with a DJI Mavic Pro 2, featuring processed video frames of EAH Jena's buildings. Agisoft Metashape was used to generate 3D reconstructions, aligned to real-world orientation with adjusted camera properties."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/shadowremovalCT2.webp'} onClick={() => navigate('/Projects/Datasets/Sunlit3D')} title="Sunlit3D Dataset" caption="The Sunlit3D dataset provides post-processed 3D building reconstructions for shadow removal. Licensed models from SketchFab with minimal shading were re-illuminated,  and lighting baked into texture maps for this purpose."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_IDD.webp'} onClick={() => navigate('/Projects/Datasets/IDD')} title="Intrinsic Decomposition Dataset" caption="CGI-rendered indoor scenes with variations in color, object arrangement, viewpoint, and lighting. Intrinsic scene properties, including semantics, geometry, and lighting decomposition, are provided."/>
        </BlockContent>
          {/* <BlockCard src={process.env.PUBLIC_URL + '/card_mineralstructura3d.webp'} onClick={() => navigate('/Projects/Datasets/ERZ')}/> */}
          
          {/* <BlockCard src={process.env.PUBLIC_URL + '/card_adam.webp'} onClick={() => navigate('/Projects/Datasets/ADAM')}/> */}
          
          
          {/* <BlockCard src={process.env.PUBLIC_URL + '/card_evermotiondataset.webp'} onClick={() => navigate('/Projects/Datasets/Evermotion')}/> */}
          {/* <BlockCard src={process.env.PUBLIC_URL + '/card_eden-I.webp'} onClick={() => navigate('/Projects/Datasets/EDEN1')}/> */}
    
      </Block>      
      <Block colorTheme="light" gridTemplateColumns="1200px">

      </Block>   
      {/* <Block colorTheme="light" width="100%">
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockTitle fontSize="25px" fontWeight="normal"></BlockTitle>
        </BlockContent>
      </Block> */}

      <Block gridTemplateColumns="300px 900px">
        <BlockContent>
          <BlockTitle>Tools</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>This section presents a collection of tools and applications developed for different purposes and use cases. Each project addresses a specific technical problem, ranging from small utilities to larger systems.</BlockText>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="400px 400px 400px">
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_colortransferlab2.webp'} onClick={() => navigate('/Projects/Applications/ColorTransferLab')} title="ColorTransferLab" caption="ColorTransferLab is a web-based app that simplifies applying and evaluating Color and Style Transfer Algorithms from the last two decades, offering users an easy-to-use interface for exploration."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_immersedecorvr2.webp'} onClick={() => navigate('/Projects/Applications/ImmerseDecorVR')}  title="ImmerseDecorVR" caption="ImmerseDecorVR is a Virtual Reality app showcasing my 3D reconstruction and color transfer work, allowing users to explore and recolor detailed reconstructions of objects and rooms in an immersive experience."/>
        </BlockContent>
        {/* <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/card_ssrdemo.webp'} onClick={() => navigate('/Projects/Applications/SsrDemoTool')} caption="..."/>
        </BlockContent> */}
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_lifetick.webp'} onClick={() => navigate('/Projects/Applications/Blank')} title="LifeTick" caption="LifeTick is a minimalistic web tool that visualizes your life’s timeline, showing both the weeks you’ve lived and the weeks you have left, based on your birth date and the average life expectancy."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_wiimenu.webp'} onClick={() => window.open("https://potechius.com/WiiMenu")} title="WiiMenu" caption="This React project is a web interface inspired by the Wii Menu. Currently, it only contains links to funny videos, so it doesn’t have a specific purpose yet."/>
        </BlockContent> 
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/RayViz.webp'} onClick={() => navigate('/Projects/Applications/RayVisualizer')}  title="Artec Ray Visualizer" caption="This tool provides interactive visualization for 3D point cloud data captured with the Artec Ray scanner. In addition to the geometry, it supports the display of supplementary scene information such as semantic labels and depth maps."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/3DLabelingTool.webp'} onClick={() => navigate('/Projects/Applications/PointCloudLabelingTool')}  title="Point Cloud Labeling Tool" caption="This tool enables interactive and user-friendly annotation of 3D point clouds in PLY format. It is provided as a web-based application."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/comingsoon.webp'} title="Family Tree" caption="This self-hosted web application enables the creation and management of family trees. Individuals and relationships are stored in a SQL database and can be easily edited through the web interface."/>
        </BlockContent>
      </Block>


      <Block  colorTheme="light" gridTemplateColumns="300px 900px">
        <BlockContent>
          <BlockTitle>Teaching</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>This section presents teaching materials and resources I have developed for various courses and workshops.</BlockText>
        </BlockContent>
      </Block>

      <Block  colorTheme="light" gridTemplateColumns="400px 400px 400px">
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_MLR.webp'} onClick={() => navigate('/Projects/Teaching/MLR')} title="Lecture: Multiple Linear Regression (German)" caption="This lecture covers the fundamentals of multiple linear regression, including the underlying mathematical concepts, its differences from simple linear regression, and methods for evaluating such models."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_CLU.webp'}  onClick={() => navigate('/Projects/Teaching/Clustering')} title="Lecture: Clustering (German)" caption="This lecture covers the fundamentals of clustering, with a particular focus on the k-means algorithm and methods for evaluating clustering results."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_gan.webp'}  onClick={() => navigate('/Projects/Teaching/GAN')}  title="Lecture: Generative Adversarial Networks (German)" caption="This lecture covers the basics of generative adversarial networks, including their architecture, training process, and applications."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_dim.webp'}  onClick={() => navigate('/Projects/Teaching/DimensionReduction')} title="Lecture: Dimensionality Reduction (German)" caption="A lecture about dimensionality reduction techniques explained in the context of clustering."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_AI-Seminar.webp'}  onClick={() => navigate('/Projects/Teaching/AISeminar')} title="Seminar: Historical Development of Artificial Intelligence and Machine Learning (German)" caption="A lecture about the historical development of artificial intelligence and machine learning, covering key concepts, milestones, and influential approaches from early symbolic AI to modern deep learning."/>
        </BlockContent>
        <BlockContent textAlign="center">
          <BlockCard src={process.env.PUBLIC_URL + '/images/project_cards/card_ganseminar.webp'}  onClick={() => navigate('/Projects/Teaching/GANSeminar')} title="Seminar: Generative Adversarial Networks (GANs) and Deepfakes (German)" caption="A seminar about Generative Adversarial Networks (GANs) and Deepfakes, covering their principles, applications, and impact on digital media."/>
        </BlockContent>
      </Block>


      {/* <Block width="100%">
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockTitle fontSize="25px" fontWeight="normal"></BlockTitle>
        </BlockContent>
      </Block> */}




      <Footer/>
    </div>
  );
}

export default Projects;
